import { lazy, Suspense } from 'react';

const Duck = lazy(() => import('@/features/duck'));

export default function DuckSection() {
  return (
    <section
      role="banner"
      className="flex flex-col items-center justify-evenly md:flex-row"
    >
      <div className="p-5 text-left">
        <div className="mb-4 text-nowrap">
          <h1 className="text-shadow-2xs">Fullstack developer</h1>
          <h1 className="text-shadow-2xs">Linux enthusiast</h1>
          <h1 className="text-shadow-2xs">Master's student in AI</h1>
        </div>
        {/* <p className="text-wrap">I'am obsessed with programming since 2021.</p> */}
        <p className="font-zen-maru-gothic font-medium tracking-tight text-shadow-2xs">
          2021年からプログラミングに夢中になっています
        </p>
      </div>
      <div>
        {/* oxlint-disable-next-line react-perf/jsx-no-jsx-as-prop */}
        <Suspense fallback={<DuckFallback />}>
          <Duck />
        </Suspense>
      </div>
    </section>
  );
}

function DuckFallback() {
  return (
    <div className="flex size-100 flex-col items-center justify-center gap-4 text-center md:size-120 xl:size-150">
      <h3 className="font-zen-maru-gothic font-medium tracking-tight">
        アヒルを待っている
      </h3>
      <div className="loader"></div>
    </div>
  );
}
